import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ag-full-details',
  templateUrl: './ag-full-details.component.html',
  styleUrls: ['./ag-full-details.component.css', '../../../quote.component.css']
})
export class AgFullDetailsComponent implements OnInit {
  quote;
  quoteData;
  @Input() set quoteDetails(value: any) {
    if (value) { this.quote = value; this.quoteData = value; }
  }
  constructor() { }
  ngOnInit(): void { }

  /**
   * Every address the vehicle is kept at overnight, as one line. A vehicle can be kept at
   * several; `postcode` only ever holds the first, so the rest come from the list beside it.
   */
  overnightPostcodes(vehicle: any): string {
    const listed = (vehicle?.overnight_addresses || [])
      .map((a: any) => (a?.postcode || '').toString().trim())
      .filter((p: string) => p);
    const all = listed.length ? listed : [(vehicle?.postcode || '').toString().trim()];
    return all.filter((p: string, i: number) => p && all.indexOf(p) === i).join(', ');
  }
}
